// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PrincipalSummary
 */
export interface PrincipalSummary {
    /**
     * 
     * @type {string}
     * @memberof PrincipalSummary
     */
    company_id: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrincipalSummary
     */
    email: string;
    /**
     * 
     * @type {number}
     * @memberof PrincipalSummary
     */
    grant_count: number;
    /**
     * 
     * @type {string}
     * @memberof PrincipalSummary
     */
    principal_id: string;
    /**
     * 
     * @type {string}
     * @memberof PrincipalSummary
     */
    status: PrincipalSummaryStatusEnum;
}


/**
 * @export
 */
export const PrincipalSummaryStatusEnum = {
    Active: 'active',
    Pending: 'pending'
} as const;
export type PrincipalSummaryStatusEnum = typeof PrincipalSummaryStatusEnum[keyof typeof PrincipalSummaryStatusEnum];


/**
 * Check if a given object implements the PrincipalSummary interface.
 */
export function instanceOfPrincipalSummary(value: object): value is PrincipalSummary {
    if (!('company_id' in value) || value['company_id'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('grant_count' in value) || value['grant_count'] === undefined) return false;
    if (!('principal_id' in value) || value['principal_id'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function PrincipalSummaryFromJSON(json: any): PrincipalSummary {
    return PrincipalSummaryFromJSONTyped(json, false);
}

export function PrincipalSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrincipalSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'company_id': json['company_id'],
        'email': json['email'],
        'grant_count': json['grant_count'],
        'principal_id': json['principal_id'],
        'status': json['status'],
    };
}

export function PrincipalSummaryToJSON(json: any): PrincipalSummary {
    return PrincipalSummaryToJSONTyped(json, false);
}

export function PrincipalSummaryToJSONTyped(value?: PrincipalSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'company_id': value['company_id'],
        'email': value['email'],
        'grant_count': value['grant_count'],
        'principal_id': value['principal_id'],
        'status': value['status'],
    };
}
